// extracted by mini-css-extract-plugin
export default {"container":"Params_container__mnMvS","row":"Params_row__bWPN9","col":"Params_col__otm9E"};